import api, {config} from './api';

const service = {
  getResourceDocuments: params => api.get('documents/resources', params),
  enumerate: params => api.get('documents', params),
  createReportToken: payload => api.post('documents/download', payload),
  createAllReportTokens: (sysRowId, payload) =>
    api.post(`documents/download-all/${sysRowId}`, payload),
  createUploadedJobDocUrl: async jobDocId => {
    const response = await api.get(
      `documents/uploaded-job-doc/generate/${jobDocId}`
    );
    if (response.hasErrors) {
      return undefined;
    }

    return `${config.baseURL}documents/uploaded-job-doc/${response.result}`;
  },
  createRepairCertUrl: async jobId => {
    const response = await api.get(`documents/repair-cert/generate/${jobId}`);
    if (response.hasErrors) {
      return undefined;
    }

    return `${config.baseURL}documents/repair-cert/${response.result}`;
  },
};

export default service;